import PropTypes from 'prop-types';
import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import R from 'ramda';

import classNames from 'classnames';
import styles from './image.css';

const { figure, figcaption, img } = hh(h);

const Image = ({
    figureClasses = [],
    imageClasses = [],
    caption = '',
    alt,
    ...props
}) => {

    const captionElement = R.isEmpty(caption) ? null : figcaption({className: styles.caption}, caption);

    return figure({className: classNames(styles.container, ...figureClasses)}, R.reject(R.isNil, [
        img({
            alt,
            className: classNames(styles.image, ...imageClasses),
            ...props
        }),
        captionElement
    ]));
};

Image.propTypes = {
    figureClasses: PropTypes.arrayOf(PropTypes.string),
    imageClasses: PropTypes.arrayOf(PropTypes.string),
    alt: PropTypes.string.isRequired,
    description: PropTypes.string
};

export default Image;



/** WEBPACK FOOTER **
 ** ./src/Image/index.js
 **/